<template>
  <div class="bill">
    <div class="title text-no">
      <div class="flex1">
        <div
          class="tabs"
          :class="billIndex == 1 ? 'tabBorder' : ''"
          @click="cutover(1)"
        >
          全部账单
        </div>
        <div
          class="tabs"
          :class="billIndex == 2 ? 'tabBorder' : ''"
          @click="cutover(2)"
        >
          本期账单
        </div>
        <div
          class="tabs"
          :class="billIndex == 3 ? 'tabBorder' : ''"
          @click="cutover(3)"
        >
          未出账单
        </div>
        <div
                class="tabs"
                :class="billIndex == 4 ? 'tabBorder' : ''"
                @click="cutover(4)"
        >
          差异管理
        </div>
         <div
                class="tabs"
                :class="billIndex == 5 ? 'tabBorder' : ''"
                @click="cutover(5)"
        >
          文件下载
        </div>
      </div>
    </div>
    <div class="main">
      <all v-if="billIndex == 1"></all>
      <periods v-if="billIndex == 2"></periods>
      <notOut v-if="billIndex == 3"></notOut>
      <manageDiffer v-if="billIndex == 4"></manageDiffer>
      <asyncDileDownload v-if="billIndex == 5"></asyncDileDownload>
    </div>
  </div>
</template>
<script>
import all from "./compnent/all.vue";
import periods from "./compnent/periods.vue";
import notOut from "./compnent/notOut.vue";
import manageDiffer from "./compnent/manageDiffer.vue";
import asyncDileDownload from "./compnent/asyncDileDownload.vue";
import { paths } from "../../utils/pathNew";
import { mapState } from "vuex";
import API from "@/api/bill";
const api = new API();
export default {
  data() {
    return {
      // billIndex: 2,
    };
  },
  components: {
    all,
    periods,
    notOut,
    manageDiffer,
    asyncDileDownload
  },
  computed: {
    ...mapState({
      billIndex: function (state) {
        return state.billIndex;
      },
    }),
  },
  methods: {
    cutover(i) {
      if (i == this.billIndex) return;
      // this.billIndex = i;
      this.$store.commit("billIndex", i);
      window.localStorage.setItem("billIndex", i);
      window.sessionStorage.setItem("billIndex", i);
    },
         //获取弹窗消息
    async queryPCPromptSign(){
      let formData = {
        promptSignCode:"MSC_WEB_PC_SIGN_00000001"
      }
      let res = await api.queryPCPromptSign(formData)
      if(res.success && res.data && res.data != ""){
        this.$notify.info({
          title: '温馨提示',
          dangerouslyUseHTMLString: true,
          message: res.data,
          position: 'bottom-right'
        });
      }
    },
  },
  created() {
    // Tab 导航栏 样式跟随
    let url = window.location.hash;
    this.$store.commit("urlIndex", paths(url));
    if (!this.$store.state.simpleNoticeState && this.billIndex == 1) {
      this.queryPCPromptSign();
      this.$store.commit("setSimpleNoticeVal", true);
    }
  },

};
</script>

<style lang="less" scoped>
.bill {
  font-family: 'Avenir', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: #f7f7f8ff;
  .title {
    display: flex;
    justify-content: center;
    min-height: 44px;
    line-height: 42px;
    box-shadow: 0px 9px 20px 0px rgba(102, 139, 204, 0.04);
    border: 1px solid #ececec;
    background-color: #fff;
    .flex1 {
      display: flex;
      cursor: pointer;
      .tabs {
        width: 64px;
        margin-right: 48px;
        &:hover {
          color: #008cffff;
          border-bottom: 2px solid #008cffff;
          max-width: 64px;
        }
      }
    }
  }
  .main {
    flex: 1;
    overflow: hidden;
    border-radius: 4px;
    margin: 24px 32px;
    overflow-y: auto;
    min-height: 524px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 1, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }
  }
}
.tabBorder {
  border-bottom: 2px solid #008cffff;
  min-width: 64px;
  color:#008cffff ;
}
</style>
